module.exports = __webpack_public_path__ + "img/media-7.7aba9bbe.png";